import { all, takeEvery, put, call, select } from 'redux-saga/effects';
import {
    getAllWorkspacesApi,
    getInvitedWorkspace,
    getWorkspaceDetailsApi,
    getWorkspacesToAllocate
} from "../../services/workspace.service";
import actions from "./actions";
import {ReducerType} from "../reducer.type";

import addressesActions from "../addresses/actions"
import attributesActions from "../attributes/actions"
import customerConfigurationActions from "../customer_configuration/actions"
import consentsActions from "../consents/actions"
import contactsActions from "../contacts/actions"
import documentsActions from "../documents/actions"
import vehicleActions from "../vehicles/actions"
import statisticsActions from "../statistics/actions"
import clientActions from "../client/actions"
import { AxiosResponse } from 'axios';
import { WorkspaceType } from '../user/user.type';

const activeWorkspace = (state: ReducerType) => state.user.activeWorkspace;

export function* GET_ALL_WORKSPACES() {
    try {
        const response: AxiosResponse<any> = yield call(getAllWorkspacesApi);
        if (response.data) {
            yield put({
                type: actions.SET_DATA,
                payload: response.data
            })
        }
    } catch (e) {

    }
}

export function* GET_WORKSPACE_DETAILS(action: {payload: string, type: any}) {
    try{
        const response: AxiosResponse<any> = yield call(
          getWorkspaceDetailsApi,
          action.payload
        );
        if (response){
            yield put({
                type: actions.SET_WORKSPACE_DETAILS,
                payload: response.data
            })
        }
    }
    catch (e) {
    }
}

export function* GET_WORKSPACES_TO_ALLOCATE() {
    try{
        const response: AxiosResponse<any> = yield call(
          getWorkspacesToAllocate
        );
        if (response){
            yield put({
                type: actions.SET_WORKSPACES_TO_ALLOCATE,
                payload: response.data
            })
        }
    }
    catch (e) {
    }
}

export function* GET_INVITED_TO_WORKSPACE(){
    try{
        const workspace: WorkspaceType = yield select(activeWorkspace);
        const response: AxiosResponse<any> = yield call(
          getInvitedWorkspace,
          workspace.uuid
        );
        if (response.data){
            yield put({
                type: actions.SET_INVITED_TO_WORKSPACE,
                payload: response.data
            })
        }
    } catch (e) {

    }
}

export function* SET_INITIAL_WORKSPACE_COMBINED_DATA(){
    try {
        yield put({
            type: addressesActions.SET_INITIAL_ADDRESSES
        })
        yield put({
            type: attributesActions.SET_INITIAL_ATTRIBUTES
        })
        yield put({
            type: customerConfigurationActions.SET_INITIAL_CONFIGURATION
        })
        yield put({
            type: consentsActions.SET_INITIAL_CONSENTS
        })
        yield put({
            type: contactsActions.SET_INITIAL_CONTACTS
        })
        yield put({
            type: documentsActions.SET_INITIAL_DOCUMENTS
        })
        yield put({
            type: vehicleActions.SET_INITIAL
        })
        yield put({
            type: statisticsActions.SET_PREV_STATISTICS,
            payload: null
        })
        yield put({
            type: clientActions.SET_INITIAL_OWNER
        })

    } catch (e) { console.log(e) }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_DATA, GET_ALL_WORKSPACES),
        takeEvery(actions.GET_WORKSPACE_DETAILS, GET_WORKSPACE_DETAILS),
        takeEvery(actions.GET_WORKSPACES_TO_ALLOCATE, GET_WORKSPACES_TO_ALLOCATE),
        takeEvery(actions.GET_INVITED_TO_WORKSPACE, GET_INVITED_TO_WORKSPACE),
        takeEvery(actions.SET_INITIAL_WORKSPACE_COMBINED_DATA, SET_INITIAL_WORKSPACE_COMBINED_DATA)
    ])
}
